import { Module } from 'vuex';
import { getters } from './getters';
import { mutations } from './mutations';
import { actions } from './actions';
import { UsersState, RootState } from '../types';
const namespaced: boolean = true;

export const state: UsersState = {
	users: [],
	count: 0
};

export const Users: Module<UsersState, RootState> = {
	namespaced,
	state,
	getters,
	mutations,
	actions
};

export default Users;
